import React from "react";
import { Button } from "./Button";
import "./Cards.css";
import { Link } from "react-router-dom";

function Cards() {
  return (
    <div className="cards">
      <div className="card-image">
        <img src="/images/hero-house2.jpeg" alt="Fenix Media" />
      </div>
      <div className="cards-content">
        <h1>Professional visual solutions for real estate</h1>
        <p>
          At Fenix Media, we focus exclusively on the real estate sector,
          working hand-in-hand with luxury developers, brokers, and property
          owners to create powerful visual storytelling. Let us help you present
          your listings in the best light and attract more buyers or renters.
        </p>
        <div className="cards-btn">
          <Link to="/portfolio">
            <Button
              buttonStyle="fm-btn--primary"
              buttonSize="fm-btn--large"
            >
              See the Difference
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Cards;
